import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../utils/propUtils';
import VeltActivityLogHeaderFilterContentItemWireframe from './VeltActivityLogHeaderFilterContentItemWireframe/VeltActivityLogHeaderFilterContentItemWireframe';
var VeltActivityLogHeaderFilterContentWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-activity-log-header-filter-content-wireframe", __assign({}, transformedProps), children));
};
VeltActivityLogHeaderFilterContentWireframe.Item = VeltActivityLogHeaderFilterContentItemWireframe;
export default VeltActivityLogHeaderFilterContentWireframe;
